/**
 * Stickytable headers for confluence
 */

import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import Utils from './utils';

/**
 * setupTable - Enable sticky tables for a group of table elements
 *
 * @param {JqueryHtmlElement} table Setup stickyheaders for tables with a defined parameter for valid tables
 * @param {Object} options StickyTableHeaders jquery plugin options
 */
const setupTable = function ($table, options) {
	// setup stalky table headers
	const $validTables = $table.filter(function () {
		return Utils.isAValidTable(this);
	});

	$validTables.stickyTableHeaders(options).addClass('stickyTableHeaders');

	bind('sticky-table-headers.change.options', (event, newOptions) => {
		$validTables.stickyTableHeaders(newOptions);
	});

	Utils.bindHorizontalScrolling($validTables);
};

/**
 * initialize stickyheaders for all confluence tables
 *
 */
const initialize = function () {
	const $table = $('.confluenceTable');
	const $win = $(window);

	// We need to abort ASAP if we're in the documentation space
	if (!Utils.isNotDocumentationTheme()) {
		return;
	}

	// the editor structure by default does not have a thead
	Utils.moveHeaderRowsToTHead($table);

	// We use mutation observer in order to trigger resizing
	if (window.MutationObserver) {
		// we need to listen to all outer container that could cause reflow
		const target = document.querySelector('#page');
		if (!target) {
			return;
		}

		// we need to exclude stickyheaders own mutations
		const stickyHeadersMutationTarget = /sticky|tableFloating|confluenceTh/;

		// listen for changes in order to make sure tableHeaders are repositioned upon reflow
		const observer = new MutationObserver(
			$.debounce((mutations) => {
				let validtriggerFlag = false;
				let className;

				for (let i = 0, len = mutations.length; i < len; i++) {
					className = mutations[i].target.className;

					if (!stickyHeadersMutationTarget.test(className)) {
						validtriggerFlag = true;
						break;
					}
				}

				if (validtriggerFlag) {
					$win.trigger('resize.stickyTableHeaders');
				}
			}, 0),
		);

		// start observing
		observer.observe(target, {
			subtree: true,
			attributes: true,
			childList: true,
		});
	}

	// enable all confluence tables
	setupTable($table, {
		cacheHeaderHeight: true,
	});
};

export default {
	initialize,
	setupTable,
};
